import { ReactNode } from 'react'

import Box, { BoxProps } from '@mui/material/Box'

export default ({ children, ...rest }: { children: ReactNode } & BoxProps) => (
  // eslint-disable-next-line
  <Box display="flex" alignItems="center" {...rest}>
    {children}
  </Box>
)
